const APP_CONSTANTS = {
  PROCTORING_TYPE: {
    LITE: 'lite',
    LIVE: 'live',
  },
  PROCTORING_ENGINE: {
    AI: 'AI',
    ULTRA_LITE: 'ULTRA_LITE',
  },
};

export default APP_CONSTANTS;
